import React, { useState, useEffect } from 'react';
import { FiPlus, FiEdit, FiTrash2, FiX, FiDollarSign } from 'react-icons/fi';
import { toast } from 'react-toastify';
import './StripeDetails.css';

const StripeDetails = ({ isOpen, onClose, onSave, stripeAccount = null }) => {
  const [formData, setFormData] = useState({
    accountName: '',
    publicKey: '',
    secretKey: ''
  });

  useEffect(() => {
    if (stripeAccount) {
      setFormData({
        accountName: stripeAccount.accountName || '',
        publicKey: stripeAccount.publicKey || '',
        secretKey: stripeAccount.secretKey || ''
      });
    } else {
      setFormData({
        accountName: '',
        publicKey: '',
        secretKey: ''
      });
    }
  }, [stripeAccount]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate required fields
    if (!formData.accountName.trim()) {
      toast.error('Account name is required');
      return;
    }
    
    if (!formData.publicKey.trim()) {
      toast.error('Public key is required');
      return;
    }
    
    if (!formData.secretKey.trim()) {
      toast.error('Secret key is required');
      return;
    }

    try {
      // Here you would call your API to save the Stripe account
      await onSave(formData);
      toast.success(stripeAccount ? 'Stripe account updated successfully' : 'Stripe account added successfully');
      onClose();
    } catch (error) {
      console.error('Error saving Stripe account:', error);
      toast.error('Failed to save Stripe account');
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content stripe-modal">
        <div className="modal-header">
          <h3>
            <FiDollarSign />
            {stripeAccount ? 'Edit Stripe Account' : 'Add New Stripe Account'}
          </h3>
          <button className="modal-close" onClick={onClose}>
            <FiX />
          </button>
        </div>
        
        <form onSubmit={handleSubmit} className="stripe-form">
          <div className="form-group">
            <label htmlFor="accountName">Stripe Account Name *</label>
            <input
              type="text"
              id="accountName"
              name="accountName"
              value={formData.accountName}
              onChange={handleInputChange}
              placeholder="Enter your Stripe account name"
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="publicKey">Stripe Public Key *</label>
            <input
              type="text"
              id="publicKey"
              name="publicKey"
              value={formData.publicKey}
              onChange={handleInputChange}
              placeholder="pk_live_... or pk_test_..."
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="secretKey">Stripe Secret Key *</label>
            <input
              type="password"
              id="secretKey"
              name="secretKey"
              value={formData.secretKey}
              onChange={handleInputChange}
              placeholder="sk_live_... or sk_test_..."
              required
            />
          </div>
          
          <div className="form-actions">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              {stripeAccount ? <><FiEdit /> Update Account</> : <><FiPlus /> Add Account</>}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default StripeDetails;
